import { RayClusterIcon } from "@/components/Icons/RayClusterIcon";
import type { ComponentType } from "react";
// import { MegaRayIcon } from "@/components/Icons/MegaRayIcon";
// import { LudwigClusterIcon } from "@/components/Icons/LudwigClusterIcon";
import { ClusterType } from "@/types";
import { KubernetesIcon } from "@/components/Icons/KubernetesIcon";
// import { IoIcon } from "@/components/Icons/IoIcon";
// import { PlyTorchIcon } from "@/components/Icons/PlyTorchIcon";
// import { UnityIcon } from "@/components/Icons/UnityIcon";
// import { UnrealIcon } from "@/components/Icons/Unrealcon";
import env from "@/env";
import { BareMetalIcon } from "@/components/Icons/BareMetalIcon";
import { ContainerIcon } from "@/components/Icons/ContainerIcon";
import { VirtualMachineIcon } from "@/components/Icons/VirtualMachineIcon";
import { MagicBookIcon } from "@/components/Icons/MagicBookIcon";
import { BrainIcon } from "@/components/Icons/BrainIcon";
import { LockClosedIcon } from "@/components/Icons/LockClosedIcon";

export type DeployClusterAction = "deploy" | "request";

export type DeployClusterOption = {
  value: ClusterType | "managed-services";
  title: string;
  subtitle: string;
  icon: ComponentType<{ className?: string }>;
  action: DeployClusterAction;
  url?: string;
  disabled?: boolean;
  emailTitle?: string;
  requestClusterType?: ClusterType;
};

export const DEPLOY_CLUSTER_OPTIONS: DeployClusterOption[] = [
  {
    value: ClusterType.VMAAS,
    title: "Virtual Machines",
    subtitle: "Deploy an AI-ready virtual machine with pre-installed frameworks.",
    icon: VirtualMachineIcon,
    url: "/cloud/virtual-machines/create-cluster",
    disabled: !env.FEATUREFLAG_VMAAS_DEPLOY,
    action: "deploy"
  },
  {
    value: ClusterType.CONTAINER,
    title: "Container Engine",
    subtitle: "Deploy your cluster of containers, powered by high-performance hardware",
    icon: ContainerIcon,
    url: "/cloud/container/create-cluster",
    disabled: !env.FEATUREFLAG_CONTAINER_DEPLOY,
    action: "deploy"
  },
  {
    value: "managed-services",
    title: "Managed Services",
    subtitle:
      "Request access to Bare Metal, Kubernetes, Ray, and Confidential Compute managed services",
    icon: RayClusterIcon,
    action: "request",
    requestClusterType: ClusterType.BARE_METAL
  }
];

export const CLUSTER_ITEMS = [
  {
    value: ClusterType.VMAAS,
    title: "Virtual Machine",
    subtitle: "Deploy an AI-ready virtual machine with pre-installed frameworks.",
    icon: VirtualMachineIcon,
    url: "/cloud/virtual-machines/create-cluster",
    disabled: !env.FEATUREFLAG_VMAAS_DEPLOY
  },
  {
    value: ClusterType.CONTAINER,
    title: "Container Engine",
    subtitle: "Deploy your cluster of containers, powered by high-performance hardware",
    icon: ContainerIcon,
    url: "/cloud/container/create-cluster",
    disabled: !env.FEATUREFLAG_CONTAINER_DEPLOY
  },
  {
    value: ClusterType.KUBERNETES,
    title: "Kubernetes",
    subtitle: "Deploy a Decentralized Kubernetes Cluster",
    icon: KubernetesIcon,
    url: "/cloud/kubernetes/create-cluster",
    disabled: true
  },
  {
    value: ClusterType.BARE_METAL,
    title: "Bare Metal",
    subtitle: "Deploy a Bare Metal Cluster",
    icon: BareMetalIcon,
    disabled: true,
    url: "/cloud/bare-metal/",
    emailTitle: "Bare Metal managed"
  },
  {
    value: ClusterType.CONFIDENTIAL_COMPUTE,
    title: "Confidential Compute",
    subtitle: "Secure AI Workloads with Hardware Enforced Encryption",
    icon: LockClosedIcon,
    disabled: true,
    url: "/cloud/confidential-compute/",
    emailTitle: "Confidential Compute managed"
  },
  // {
  //   value: ClusterType.RAY,
  //   title: "Ray",
  //   subtitle: "Deploy a Decentralized Ray Cluster",
  //   icon: RayClusterIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: !env.FEATUREFLAG_CLUSTER_DEPLOYMENT_ENABLED
  // }
  // {
  //   value: ClusterType.LUDWIG,
  //   title: "Ludwig",
  //   subtitle: "Declarative deep learning framework built for scale and efficiency.",
  //   icon: LudwigClusterIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: true
  // },
  // {
  //   value: ClusterType.RAY_APP,
  //   title: "Ray LLM",
  //   subtitle: "LLM serving at scale built on Ray Serve.",
  //   icon: RayClusterIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: true
  // },
  // {
  //   value: "pytorch",
  //   title: "PyTorch FSDP",
  //   icon: PlyTorchIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: true
  // },
  // {
  //   value: "ionative",
  //   title: "IO Native App",
  //   icon: IoIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: true
  // },
  // {
  //   value: "unrealengine5",
  //   title: "Unreal Engine 5",
  //   icon: UnrealIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: true
  // },
  // {
  //   value: "unitystreaming",
  //   title: "Unity Streaming",
  //   icon: UnityIcon,
  //   url: "/cloud/clusters/create-cluster",
  //   disabled: true
  // }
];

export const VM_IMAGE_OPTIONS = [
  {
    value: "general",
    label: "General Purpose Image",
    description:
      "OS: Ubuntu 24.04 64Bit \nSize: 3.5 GB (Uncompressed)\nAlong with NVIDIA CUDA Toolkit and associated drivers",
    cardIcon: MagicBookIcon,
    OsName: "Ubuntu 24.04 64Bit",
    OsSize: "3.5 GB (Uncompressed)",
    OsDescription: "Along with NVIDIA CUDA Toolkit and associated drivers"
  },
  {
    value: "datascience",
    label: "Data Science Image",
    description:
      "OS: Ubuntu 24.04.2 LTS x86_64/amd64 \nSize: 50GB\nNVIDIA drivers and CUDA libraries are pre-configured",
    cardIcon: BrainIcon,
    OsName: "Ubuntu 24.04.2 LTS x86_64/amd64",
    OsSize: "50GB",
    OsDescription: "NVIDIA drivers and CUDA libraries are pre-configured"
  }
];

export const RESTRICT_TO_SINGLE_LOCATION = false;

export const MAP_RESOURCE_TYPE_TO_CLUSTER_TYPE: { [key: string]: ClusterType } = {
  caas: ClusterType.CONTAINER,
  baremetal: ClusterType.BARE_METAL,
  "confidential-compute": ClusterType.CONFIDENTIAL_COMPUTE,
  ray: ClusterType.RAY,
  vmaas: ClusterType.VMAAS,
  k8s_cluster: ClusterType.KUBERNETES,
  k8s_nomad: ClusterType.KUBERNETES,
  cluster: ClusterType.RAY,
  vmaas_external: ClusterType.VMAAS,
  caas_external: ClusterType.CONTAINER
};

export const isRayClusterResourceType = (resourceType?: string) =>
  MAP_RESOURCE_TYPE_TO_CLUSTER_TYPE[resourceType ?? ""] === ClusterType.RAY;

export const CLUSTER_TYPE_FILTER_OPTIONS = [
  { value: "caas", label: "Container As a Service" },
  { value: "baremetal", label: "Bare Metal" },
  { value: "confidential-compute", label: "Confidential Compute" },
  { value: "cluster", label: "Ray" },
  { value: "vmaas", label: "Virtual Machine" },
  { value: "k8s_cluster", label: "Kubernetes" }
];

export const DEEP_LINK_GPU_COOKIE_KEY = "deep_link_gpu";
export const DEEP_LINK_LOCATION_COOKIE_KEY = "deep_link_location";
